import Ws from '@adonisjs/websocket-client';
import api from './api.service';

let ws = false;

let isConnected = false;
let common = false;

// console.log(`ws${process.env.NODE_ENV !== 'production' ? '' : 's'}://${api.domain}`);
console.log('ws://localhost:4777');

const connect = (token) => {
  ws = Ws('ws://localhost:4777');
  ws.withJwtToken(token).connect();
  ws.on('open', () => {
    isConnected = true;
    console.log("ws.on('open'");
  });
  ws.on('close', () => {
    isConnected = false;
    console.log("ws.on('close'");
  });

  common = ws.subscribe('common');
  common.on('ready', () => {
    common.emit('channel', {
      name: 'test 1',
      is_public: true,
    });
  });
  // chat.on('error', (error) => {
  //   console.log(error);
  // });
  //
  // chat.on('close', () => {
  // });
  //
  common.on('readyVideo', (data) => {
    console.log('readyVideo', data);
  });
};

export default {
  connect,
  ws,
  common,
};



// WEBPACK FOOTER //
// ./src/services/socket.service.js